import client from '../client';

class WareHouseService {
    getWareHouse(searchParam) {
        const url = `admin/wholesalers?search_param=${searchParam}`;
        return client.get(url).then(({ data }) => data);
    }
}

export default new WareHouseService();